import { createClient } from '@supabase/supabase-js';

// On récupère les variables d'environnement définies plus tôt
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Il manque les variables d\'environnement Supabase dans le fichier .env');
}

// On exporte le client prêt à l'emploi
export const supabase = createClient(supabaseUrl, supabaseKey);